var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M3.349 1.674a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0zm0 5.581a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0zm0 5.58a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0zm14.51-.557v1.116c0 .308-.25.558-.558.558H6.139a.558.558 0 0 1-.558-.558v-1.116c0-.308.25-.558.558-.558h11.162c.308 0 .558.25.558.558zm0-11.162v1.116c0 .309-.25.558-.558.558H6.139a.558.558 0 0 1-.558-.558V1.116c0-.308.25-.558.558-.558h11.162c.308 0 .558.25.558.558zm0 5.581v1.116c0 .308-.25.558-.558.558H6.139a.558.558 0 0 1-.558-.558V6.697c0-.308.25-.558.558-.558h11.162c.308 0 .558.25.558.558z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.e31e0102.svg";
export { ForwardRef as ReactComponent };